<div
	ada-chat-bubble
	[isActive]="isActive()"
	[menuTemplate]="menuTemplate()"
	[message]="message()"
	[timestampTemplate]="timestampTemplate()"
>
	@let _dashboard = dashboard();

	<button
		ada-background-color="background"
		class="ada-dashboard-artifact ada-border ada-text-align-left"
		[class.ada-cursor-pointer]="!!_dashboard"
		(click)="_dashboard && openDashboard()"
	>
		@if (_dashboard) {
			<span
				ada-font-weight="bold"
				ada-type="small"
			>
				{{ _dashboard.name }}
			</span>
		} @else {
			<ada-spinner
				size="small"
				[inheritColor]="true"
			/>
		}
	</button>
</div>
